var spinnerMaxDisplayDuration = 3000;
var spinnerStopped = false;

$(window).on("load", function() {
if(!spinnerStopped){
    stopSpinner();
}
});
$(window).resize(function() {

        sizeDesktopSpacer();
});

setTimeout(function(){
    if(!spinnerStopped){
        stopSpinner();
    }
},spinnerMaxDisplayDuration);
function sizeDesktopSpacer() {
    var spacer = $('#desktop-spacer');
    var note = $('.checkout-notice');
    spacer.height(note.outerHeight(true));
}

function changePriceOption(obj, id) {
    var scope;

    scope = angular.element(obj).scope();
    scope.editPriceOption=false;
    scope.changePriceOption(scope.priceOptionItem[id], 'save', scope.priceOptionItem[id].key, obj.value);
}


$( document ).ready(function() {
  // no css because some clients have her own custom_css
  $('.progressbar').css('background-color', $('body').css('background-color'));
    $('a.modalTrigger').leanModal({closeButton: '.close'});

    // Pull out all modals from nested elements and attach them to the wrapper
    $('.modal').each(function(){
        $(this).appendTo('#wrapper');
    });


});



function sc(value){
    var body = $('div.ng-scope');
    if(value){
        return angular.element(body).scope()[value];
    }
    else{
        return angular.element(body).scope();

    }
}

function showDebugLog(){
    var body = $('div.ng-scope');
    var log = angular.element(body).scope()["debugLog"];
    for (var i = 0; i < log.length; i++){
        console.error(log[i]);
    }
}

function showEmptyCartModal(){
    setTimeout(function(){$('#emptycart-modal-trigger').click();},100);
}

function showPersonalizationModal() {
    setTimeout(function(){$('#personalization-modal-trigger').click();},100);
}

function showSetNewPasswordModal(){
    setTimeout(function(){$('#setnewpassword-modal-trigger').click();},100);
}

function showAddressValidationModal(){
    setTimeout(function(){$('#addressValidationWarning-modal-trigger').click();},100);
}

function showHashMismatchModal(cartSize) {
    if (cartSize === 0) {
        showEmptyCartModal();
    } else {
        setTimeout(function() {
            $('#hash-mismatch-modal-trigger').click();
        }, 100);
    }
}

function showEventInformationModal(){
    setTimeout(function() {
        $('#eventinformation-modal-trigger').click();
    }, 100);
}

function showProductAmountChangedModal(){
    setTimeout(function(){$('#productAmountChanged-modal-trigger').click();},100);
}

function onReady(callback) {
    var intervalID = window.setInterval(checkReady, 1000);

    function checkReady() {
        if (document.getElementsByTagName('body')[0] !== undefined) {
            window.clearInterval(intervalID);
            callback.call(this);
        }
    }
}

function stopSpinner(){
    document.getElementById('wrapper').style.display = 'block';
    document.getElementById('spinner').style.display = 'none';
    sizeDesktopSpacer();
    spinnerStopped = true;
}

function startSpinner(){
    document.getElementById('wrapper').style.display = 'none';
    document.getElementById('spinner').style.display = 'block';
    spinnerStopped = false;
}

function scrollToNext(currentId){
    var offset = 75;
    var current = document.getElementById(currentId);
    var next = current.nextElementSibling;
    if(currentId == "payment") next=document.getElementById('cart');
    if(next){
        var cr = next.getBoundingClientRect();
        scrollSmooth(cr.top - offset);
    }
}

function scrollSmooth(y,s){
    if (!s) var s = 0;
    var scrollAmount = 10;
        if(s < y)
        {
            setTimeout(function(){
                window.scrollBy(0,scrollAmount);
                scrollSmooth(y,s+scrollAmount);
            },10);
        }
}

// Updates the form errors for a given form ID
// using HTML 5 Validation
// each input requires a data-validation tag that holds
// the ID of the formerror div
function updateFormErrors(formID){
    var form = $('#'+formID);
    removeFormErrors(form);
    var children = form.children().children();
    children.filter('input,select').each(function(){
        if($(this).get(0).validity.valid == false){
            appendFormError($(this));
        }
    });
}

function appendFormError(input) {
    var target = input.data('validation');
    var targets = target.split(',');
    for (var i = 0; i < targets.length; i++){
        target = targets[i];
        var formError = $('#'+target);
        if(!formError.children().length){
            formError.append("<span>"+input.get(0).validationMessage+"</span>");
        }
    }
}

function removeFormErrors(form){
    form.children().filter('.formerror').html("");
}

function removeFormSubmitStatus(){
    $('form').each(function(){
        $(this).removeClass('submit');
    });
}
